import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { InfosUser } from 'app/shared/models/class/auth/infosUser';
import { PracticePlace } from 'app/shared/models/class/practice-place/PracticePlace';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { PracticePlaceService } from 'app/shared/services/practice-place/pratcice-place.service';
import { UiService } from 'app/shared/services/ui/ui.service';

export interface DialogData {
  action: string;
  praticePlace: PracticePlace;
}

type switchOptions = {
  [key: string]: any
};

@Component({
  selector: 'app-open-dialog-add-edit-practice-place',
  templateUrl: './open-dialog-add-edit-practice-place.component.html',
  styleUrls: ['./open-dialog-add-edit-practice-place.component.scss']
})
export class OpenDialogAddEditPracticePlaceComponent implements OnInit {

  searchPracticePlaceForm: UntypedFormGroup;
  newPracticeplace = new PracticePlace();
  userConnected: InfosUser;
  clubCode: any;
  title: string;
  btnConfirm: string;
  text: string;
  isLoadingCreation = false;

  constructor(
    private formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<OpenDialogAddEditPracticePlaceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private authService: AuthService,
    private route: ActivatedRoute,
    private practicePlaceService: PracticePlaceService,
    private uiService: UiService
  ) { }

  ngOnInit(): void {
    this.initComponent();
    this.initForm();
  }

  onSubmit(): void {
    this.isLoadingCreation = true;
    this.newPracticeplace.label = this.f.label.value;

    switch (this.data.action) {
      case 'add':
        this.practicePlaceService.addPracticePlace(this.newPracticeplace).subscribe({
          next: () => {
            this.isLoadingCreation = false;
            this.dialogRef.close()
          }
        });

        break;
      case 'edit':
        this.newPracticeplace = this.newPracticeplace ? this.newPracticeplace : this.data.praticePlace;
        this.newPracticeplace.practicePlaceKey = this.data.praticePlace.practicePlaceKey;
        if (this.newPracticeplace !== null) {
          this.practicePlaceService.updatePracticePlace(this.newPracticeplace).subscribe({
            next: () => {
              this.isLoadingCreation = false;
              this.dialogRef.close()
            }
          });
        } else {
          this.isLoadingCreation = false;
          this.uiService.showSnackbar('Vous n\'avez pas indiqué d\'adresse.');
        }

        break;

      default:
        break;
    }
  }

  getAddressPracticePlace(event): void {
    event.address_components.forEach(el => {
      switch (el.types[0]) {
        case 'street_number':
          this.newPracticeplace.box = el.long_name;
          break;

        case 'route':
        case 'town_square':
          this.newPracticeplace.address = el.long_name;
          break;

        case 'locality':
          this.newPracticeplace.city = el.long_name;
          break;

        case 'postal_code':
          this.newPracticeplace.postalCode = el.long_name;
          break;

        case 'administrative_area_level_2':
          this.newPracticeplace.department = el.long_name;
          break;

        case 'administrative_area_level_1':
          this.newPracticeplace.region = el.long_name;
          break;

        case 'country':
          this.newPracticeplace.country = el.long_name;
          break;

        default:
          break;
      }
    });

    this.newPracticeplace.latitude = event.geometry.location.lat();
    this.newPracticeplace.longitude = event.geometry.location.lng();
    this.newPracticeplace.clubCode = this.clubCode;
  }

  private getLabel(type: string): string {
    const label: switchOptions = {
      add: {
        title: 'Ajouter une discipline',
        confirm: 'Ajouter',
        text: 'Lieu de pratique ajouté'
      },
      edit: {
        title: 'Modifier la discipline',
        confirm: 'Mettre à jour',
        text: 'Lieu de pratique mis à jour',
      },
    };
    return label[this.data.action][type];
  }

  private initComponent(): void {
    this.userConnected = this.authService.getDecodedToken();

    const clubCode = {
      admin: this.route.snapshot.queryParams.clubCode,
      club: this.userConnected.club_code
    };

    this.clubCode = clubCode[this.userConnected.role];
    this.title = this.getLabel('title');
    this.btnConfirm = this.getLabel('confirm');
    this.text = this.getLabel('text');
  }

  get f() {
    return this.searchPracticePlaceForm.controls;
  }

  private initForm(): void {
    let label = '';
    if (this.data.praticePlace) {
      label = this.data.praticePlace.label;
    }
    this.searchPracticePlaceForm = this.formBuilder.group({
      label: [label, Validators.required],
      practicePlace: ['', Validators.required]
    });
  }
}
